import { Star } from "lucide-react";

export const Stars = ({ count = 5, className = "", size = 16 }) => (
  <div className={`flex items-center gap-1 ${className}`} aria-label={`${count} out of 5 stars`}>
    {Array.from({ length: count }).map((_, i) => (
      <Star key={i} size={size} className="fill-gold text-gold" strokeWidth={1} />
    ))}
  </div>
);
